import React from 'react'
import useUser from 'admin/hooks/useUser'
import useStateObject from 'admin/hooks/useStateObject'
import useDocument from 'admin/hooks/useDocument'
import InputField from 'admin/components/shared/InputField'
import Modal from 'admin/components/shared/Modal'
import Tags from 'admin/components/shared/Tags'
import AccountField from 'admin/components/shared/AccountField'
import {useParams, useHistory} from 'react-router-dom'
import EditField from '../shared/EditField'
import Header from '../shared/Header'
import useModal from '../../hooks/useModal'

export default () => {
  const history = useHistory()
  const {organisationID} = useParams()
  const {popModal} = useModal()
  const {user, errors, create} = useUser(organisationID)
  const [form, setForm, resetForm] = useStateObject({accounts: []})

  useDocument({title: 'New user'})

  const handleCreate = e => {
    e.preventDefault()
    create(form, () => history.replace(`/orgs/${organisationID}/users`))
  }

  const handleRemoveAccount = account => {
    setForm({accounts: form.accounts.filter(a => String(a.id) !== String(account.id))})
  }

  const handleAddAccount = account => {
    setForm({accounts: form.accounts.concat(account)})
  }

  const handleClose = e => {
    e.preventDefault()
    resetForm(user)
    popModal('new-user')
  }

  return (
    <Modal onClose={handleClose} flashId='new-user'>
      <Header title='New user'>
        <button className='button is-primary' onClick={handleCreate}>
          Create
        </button>
      </Header>
      <section className='section'>
        <div className='container'>
          <form onSubmit={handleCreate}>
            <EditField
              onChange={setForm}
              values={{firstName: form.firstName, lastName: form.lastName}}
              errors={{firstName: errors.firstName, lastName: errors.lastName}}
            />
            <div className='block'>
              <InputField type='text' name='email' value={form.email} onChange={setForm} errors={errors.email} />
              <InputField
                type='checkbox'
                name='sendInvitation'
                checked={form.sendInvitation}
                label='Send invitation'
                onChange={setForm}
                errors={errors.sendInvitation}
                help='Email this user with a link to set up a password'
              />
            </div>
            <div className='block'>
              <label htmlFor='account_name' className='label is-small'>
                Accounts
              </label>
              <Tags selected={form.accounts} onDeselect={handleRemoveAccount} />
              <AccountField
                organisationID={organisationID}
                onSelect={handleAddAccount}
                exclude={form.accounts.reduce((exclusions, account) => {
                  exclusions.push(account.id)
                  return exclusions
                }, [])}
              />
            </div>
          </form>
        </div>
      </section>
    </Modal>
  )
}
